import type { Campaign, CreateDisparoRequest } from '../types';

/**
 * Valores usados ao criar a fila de disparo no primeiro Play no Kanban
 * quando a campanha não tem preferências gravadas (campanhas antigas ou sem passo 3).
 */
export const CAMPAIGN_QUICK_DISPARO_DEFAULTS = {
  intervaloMinutos: 5,
  horaInicio: '09:00',
  horaFim: '18:00',
  maxDisparosPorNumero: 100,
} as const;

/** Corpo para POST /disparos: merge(campanha, defaults globais). */
export function buildCreateDisparoBodyFromCampaignDefaults(
  campaign: Pick<
    Campaign,
    | 'campaignId'
    | 'defaultDisparoIntervaloMinutos'
    | 'defaultDisparoMaxDisparosPorNumero'
    | 'defaultDisparoHoraInicio'
    | 'defaultDisparoHoraFim'
    | 'defaultDisparoAutoResumeOnMax'
  >,
  whatsappAccountId: string
): CreateDisparoRequest {
  const def = CAMPAIGN_QUICK_DISPARO_DEFAULTS;
  return {
    campaignId: campaign.campaignId,
    whatsappAccountId,
    intervaloMinutos: campaign.defaultDisparoIntervaloMinutos ?? def.intervaloMinutos,
    horaInicio: campaign.defaultDisparoHoraInicio ?? def.horaInicio,
    horaFim: campaign.defaultDisparoHoraFim ?? def.horaFim,
    maxDisparosPorNumero: campaign.defaultDisparoMaxDisparosPorNumero ?? def.maxDisparosPorNumero,
    ...(campaign.defaultDisparoAutoResumeOnMax === true ? { autoResumeOnMax: true } : {}),
  };
}
